function getClstag(text: string) {
  return `pageclick|keycount|PCZichan|${text}`;
}


function formatImgUrl(imgPath:string) {
  if(!imgPath) return ''

  imgPath = imgPath.replace(/https?:/, '')
  return imgPath
}

//获取地址栏参数
function getUrlParms (name:string) {
  var url = window.location.href
  if(!url){ return null }
  var strArr = url.split("?")
  if(!strArr || strArr.length===0){ return null}
  var str = strArr && strArr[strArr.length-1]
  str = "?" + str
  var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  var r = str.substr(1).match(reg);
  if(r!=null)
  return unescape(r[2]);
  return null;
}

function recommendParamsFilter(params: any) {
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const element = params[key];
      if (
        element === -1 ||
        (Array.isArray(element) && element[0] === -1) ||
        element === ""
      ) {
        delete params[key];
      }
    }
  }
  return params;
}

function ellipsis(string: string, cut: number = 16) {
  if (string.length > cut) {
    return `${string.slice(0, cut)}...`;
  }
  return string;
}





function fillImgPath ({
  url,
  index,
  q = 70,
  size = '800x800',
  nx = 'esf',
  wh = ''
}: any) {

  const innerUrl = url.trim()
  let returnUrl = innerUrl

  // 从公网访问图片使用的域名数组
  const domainArr = [10, 11, 12, 13, 14, 20, 30]

  // 计算图片链接hash
  const urlSplit = url.split('/')
  const hashStr = urlSplit[urlSplit.length - 1].split('.')[0]
  let total = 0
  for (let i = 0; i < hashStr.length; i++) {
    total += hashStr.charCodeAt(i)
  }

  // 获取图片使用的域名
  let selectedIndex = 0
  if (index === 0) {
    selectedIndex = 0
  } else {
    selectedIndex = index || total % domainArr.length
  }
  const randomDomain = domainArr[selectedIndex]

  // 全路径
  if (/\/jfs\//.test(innerUrl)) {
    if (/\.gif$/.test(innerUrl)) {
      returnUrl = `https://img${randomDomain}.360buyimg.com/esf/${innerUrl.split('/jfs/')[1]}${wh}`
    }
    returnUrl = `https://img${randomDomain}.360buyimg.com/${nx}/s${size}_jfs/${innerUrl.split('/jfs/')[1]}!q${q}${wh}`

  // jfs开头的路径的时候
  } if (/^jfs\//.test(innerUrl)) {
    if (/\.gif$/.test(innerUrl)) {
      returnUrl = `https://img${randomDomain}.360buyimg.com/esf/${innerUrl}${wh}`
    }

    returnUrl = `https://img${randomDomain}.360buyimg.com/${nx}/s${size}_${innerUrl}!q${q}${wh}`
  }

  return returnUrl
}

/**
 * 填充两位
 */
const fill2 = (v: number) => {
  let vStr = v + ''
  while (vStr.length < 2) {
    vStr = '0' + v
  }
  return vStr
}

/**
 * @description: 格式化剩余时间
 * @param {type} 剩余时间
 * @return: rest对象
 */
const formatRemainTime = (t: number) => {
  const ts = t
  const rest = {
    dayStr: '00',
    hourStr: '00',
    minuteStr: '00',
    secondStr: '00',
    dayNum: 0,
    hourNum: 0,
    minuteNum: 0,
    secondNum: 0
  }
  if (ts <= 0) {
    return rest
  } else {
    const ds = 24 * 60 * 60
    const hs = 60 * 60
    const ms = 60

    const d = ts >= ds ? parseInt((ts / ds).toString()) : 0
    const h = ts - d * ds >= hs ? parseInt(((ts - d * ds) / hs).toString()) : 0
    const m = ts - d * ds - h * hs >= ms ? parseInt(((ts - d * ds - h * hs) / ms).toString()) : 0
    const s = parseInt((ts - d * ds - h * hs - m * ms).toString())

    rest.dayNum = d
    rest.hourNum = h
    rest.minuteNum = m
    rest.secondNum = s
    if (d >= 0) rest.dayStr = fill2(d)
    if (h >= 0) rest.hourStr = fill2(h)
    if (m >= 0) rest.minuteStr = fill2(m)
    if (s >= 0) rest.secondStr = fill2(s)
  }
  return rest
}












export { getUrlParms, ellipsis, getClstag, formatImgUrl, recommendParamsFilter, fillImgPath, formatRemainTime };
